module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c2e1648403434547d1724a3453c74d74.png";